import { useNavigate } from 'react-router-dom';
import type { Article } from '../../types';
import { useAppContext } from '../../context/AppContext';

export default function ArticleCard({ article }: { article: Article }) {
  const navigate = useNavigate();
  const { deleteArticle } = useAppContext();
  const date = new Date(article.savedAt);
  const dateStr = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  const tokenCount = article.tokens.filter(t => t.surface !== '\n').length;

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (window.confirm(`Delete "${article.title}"? This cannot be undone.`)) {
      deleteArticle(article.id);
    }
  };

  return (
    <div
      onClick={() => navigate(`/app/articles/${article.id}`)}
      className="relative bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-5 cursor-pointer hover:shadow-md hover:-translate-y-0.5 transition-all group"
    >
      <button
        onClick={handleDelete}
        className="absolute top-3 right-3 p-1.5 rounded-lg text-slate-300 dark:text-slate-600 opacity-0 group-hover:opacity-100 hover:bg-red-50 dark:hover:bg-red-900/30 hover:text-red-500 dark:hover:text-red-400 transition-all"
        aria-label="Delete article"
      >
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
        </svg>
      </button>
      <h3 className="font-semibold text-slate-800 dark:text-slate-100 mb-2 group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors pr-8">
        {article.title}
      </h3>
      <p className="text-sm text-slate-500 dark:text-slate-400 line-clamp-2 mb-3 leading-relaxed">
        {article.content.substring(0, 100)}...
      </p>
      <div className="flex items-center gap-3 text-xs text-slate-400">
        <span>{dateStr}</span>
        <span className="w-1 h-1 rounded-full bg-slate-300 dark:bg-slate-600" />
        <span>{tokenCount} tokens</span>
      </div>
    </div>
  );
}
